import ArticleCardHome from 'Components/article_card_home'
import ButtonMore from '@fdn/button_more'
import ErrorPlaceholder from '@fdn/error_placeholder'
import {handleUrlArticle} from 'Helpers/utils'

const LatestArticleMobile = ({
  is_mobile,
  dataArticleLatest,
  moreURL,
}) => {
  return (
    <div className="latest-article section">
      <div className="section-title-wrapper">
        <h3 className="section-title bordered">Latest Article</h3>
      </div>
      <div className="latest-article-wrapper">
        {Array.isArray(dataArticleLatest) ? (
          dataArticleLatest.length ? (
            <>
              <div className="latest-article-big">
                {dataArticleLatest.slice(0, 1).map((item, idx) => (
                  <div id={`id_article_${item.id}`} key={idx}>
                    <ArticleCardHome
                      is_mobile={is_mobile}
                      is_sponsored={false}
                      font_title={`Josefin Sans, sans-serif`}
                      article={Object.assign({
                        category: {
                          name: Array.isArray(item?.parent_category_slugs) && item?.parent_category_slugs?.[0]?.replace(
                            /[-_]/g,
                            ' ',
                          ) || "",
                        },
                        date: item.created_at,
                        title: item.title,
                        text: item.excerpt,
                        image: item.image,
                        url: handleUrlArticle(item.url),
                        author: { fullname: item.author.name },
                      })}
                      url_category={`${
                        process.env.NEXT_PUBLIC_ROOT_DOMAIN
                      }/blog/category/${Array.isArray(item?.parent_category_slugs) && item?.parent_category_slugs?.[0]?.replace(
                        /[-_]/g,
                        '-',
                      ) || ""}`}
                      url_author={`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/blog/author/${item.author.username}`}
                      type={'type-2'}
                      size="main"
                    />
                  </div>
                ))}
              </div>
              <div className="latest-article-small">
                {dataArticleLatest.slice(1, 5).map((item, idx) => (
                  <div id={`id_article_${item.id}`} key={idx}>
                    <ArticleCardHome
                      is_mobile={is_mobile}
                      is_sponsored={false}
                      font_title={`Josefin Sans, sans-serif`}
                      article={Object.assign({
                        category: {
                          name: Array.isArray(item?.parent_category_slugs) && item?.parent_category_slugs?.[0]?.replace(
                            /[-_]/g,
                            ' ',
                          ) || "",
                        },
                        date: item.created_at,
                        title: item.title,
                        text: item.excerpt,
                        image: item.image,
                        url: handleUrlArticle(item.url),
                        author: { fullname: item.author.name },
                      })}
                      url_category={`${
                        process.env.NEXT_PUBLIC_ROOT_DOMAIN
                      }/blog/category/${Array.isArray(item?.parent_category_slugs) && item?.parent_category_slugs?.[0]?.replace(
                        /[-_]/g,
                        '-',
                      ) || ""}`}
                      url_author={`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/blog/author/${item.author.username}`}
                      type={'type-2'}
                      // size="big"
                    />
                  </div>
                ))}
              </div>
              <div className="btn-more-wrapper">
                <ButtonMore
                  text={'SEE ALL ARTICLES'}
                  font_family={`Josefin Sans, sans-serif`}
                  font_size={16}
                  font_weight={400}
                  color={'#000000'}
                  link={moreURL}
                  element_id={'id_see_more_article_latest'}
                />
              </div>
            </>
          ) : (
            <ErrorPlaceholder
              is_mobile={is_mobile}
              icon="https://s3-ap-southeast-1.amazonaws.com/assets.femaledaily.com/editorial/no-data-icon.svg"
              icon_alt="no data icon female daily"
              title="Sorry :("
              text="There’s no data to display"
            />
          )
        ) : (
          <ErrorPlaceholder
            is_mobile={is_mobile}
            icon="https://s3-ap-southeast-1.amazonaws.com/assets.femaledaily.com/editorial/something-wrong-icon.svg"
            icon_alt="wrong icon female daily"
            title="Uh Oh!"
            text="Something went wrong"
          />
        )}
      </div>
      <style>
        {`
          .latest-article.section {
            display: flex;
            flex-direction: column;
            align-items: center;
            border: 1px solid #F0F3F7;
          }

          .latest-article .section-title-wrapper {
            background: #FFFFFF;
            padding: 0 16px;
            width: fit-content;
            margin-top: -18px;
          }

          .latest-article .section-title.bordered {
            width: fit-content;
            font-family: Josefin Sans, sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 20px;
            letter-spacing: 0.1em;
            padding: 6px 10px 4px 10px;
            margin-bottom: 24px;
          }

          .latest-article-wrapper {
            display: flex;
            flex-wrap: wrap;
            padding: 0 12px;
            ${
              !Array.isArray(dataArticleLatest) || !dataArticleLatest.length
                ? 'padding-bottom: 24px;'
                : ''
            }
          }

          .latest-article-small .article-card-mobile-type-2 {
            margin-bottom: 15px;
          }

          .latest-article-big {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin-bottom: 20px;
          }

          .latest-article .btn-more-wrapper {
            display: flex;
            justify-content: center;
            width: 100%;
            margin-bottom: 24px;
          }

          .fdn-article-card-mobile-type-2 div.article-info a.article-title,
          .fdn-article-card-mobile-type-2.main div.article-info a.article-title {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3; 
            -webkit-box-orient: vertical;
          }
        `}
      </style>
    </div>
  )
}

export default LatestArticleMobile
